// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__OCl2R","button":"styles_button__u_d5l","buttonInner":"styles_buttonInner__WJjIU","anime":"styles_anime__f8GJ0"};